import { RotateCcw } from 'lucide-react';
import './DrawnOpeningBanner.css';

interface TakebackNoticeProps {
  /** Message to show, or null to hide. Timing/priority is owned by the parent. */
  message: string | null;
}

/**
 * Transient status banner over the board for the takeback flow: "requested…",
 * "declined", or "disabled in rated games". Purely presentational — the parent
 * (OnlineGame) decides which message is active and when it clears. Reuses the
 * drawn-opening banner styling so no new CSS is needed.
 */
export default function TakebackNotice({ message }: TakebackNoticeProps) {
  if (!message) return null;
  return (
    <div className="drawn-opening-banner" role="status" data-testid="takeback-notice">
      <span className="dob-icon" aria-hidden="true"><RotateCcw size={16} /></span>
      <span className="dob-text">
        <span className="dob-label">{message}</span>
      </span>
    </div>
  );
}
